import styled from '@emotion/styled';

interface CardboxWrapperProps {
  isPadded?: boolean;
}

const CardboxWrapper = styled.div<CardboxWrapperProps>`
  display: flex;
  min-height: 100vh;
  min-width: 100vw;
  padding: ${({ isPadded = true }) => isPadded ? '1rem' : '0'};

  @media only screen and (min-width: 900px) {
    padding: ${({ isPadded = true }) => isPadded ? '40px' : '0'};
  }
`;

export default CardboxWrapper;
